export const ButtonGoExplore = () => {
  const handleScrollToExplore = () => {
    const exploreSection = document.getElementById("explore");
    if (exploreSection) {
      exploreSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex justify-center items-center ">
      <button
        className="px-6 py-2 bg-red-600 text-white hover:bg-red-700 font-bold border-b-4 border-red-900 hover:border-red-500 transition duration-300  rounded cursor-pointer "
        onClick={handleScrollToExplore}
      >
        Explore nosso acervo de peças
      </button>
    </div>
  );
};